/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductPublicationReadMetadata
 */
export interface ProductPublicationReadMetadata {
    /**
     * 
     * @type {Date}
     * @memberof ProductPublicationReadMetadata
     */
    requestedSince?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ProductPublicationReadMetadata
     */
    requestedUntil?: Date;
    /**
     * 
     * @type {number}
     * @memberof ProductPublicationReadMetadata
     */
    expectedDayCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPublicationReadMetadata
     */
    publishedDayCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPublicationReadMetadata
     */
    complete?: boolean;
    /**
     * 
     * @type {Array<Date>}
     * @memberof ProductPublicationReadMetadata
     */
    missingDays?: Array<Date>;
}

/**
 * Check if a given object implements the ProductPublicationReadMetadata interface.
 */
export function instanceOfProductPublicationReadMetadata(value: object): value is ProductPublicationReadMetadata {
    return true;
}

export function ProductPublicationReadMetadataFromJSON(json: any): ProductPublicationReadMetadata {
    return ProductPublicationReadMetadataFromJSONTyped(json, false);
}

export function ProductPublicationReadMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPublicationReadMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'requestedSince': json['requestedSince'] == null ? undefined : (new Date(json['requestedSince'])),
        'requestedUntil': json['requestedUntil'] == null ? undefined : (new Date(json['requestedUntil'])),
        'expectedDayCount': json['expectedDayCount'] == null ? undefined : json['expectedDayCount'],
        'publishedDayCount': json['publishedDayCount'] == null ? undefined : json['publishedDayCount'],
        'complete': json['complete'] == null ? undefined : json['complete'],
        'missingDays': json['missingDays'] == null ? undefined : json['missingDays'],
    };
}

export function ProductPublicationReadMetadataToJSON(json: any): ProductPublicationReadMetadata {
    return ProductPublicationReadMetadataToJSONTyped(json, false);
}

export function ProductPublicationReadMetadataToJSONTyped(value?: ProductPublicationReadMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestedSince': value['requestedSince'] == null ? value['requestedSince'] : value['requestedSince'].toISOString().substring(0,10),
        'requestedUntil': value['requestedUntil'] == null ? value['requestedUntil'] : value['requestedUntil'].toISOString().substring(0,10),
        'expectedDayCount': value['expectedDayCount'],
        'publishedDayCount': value['publishedDayCount'],
        'complete': value['complete'],
        'missingDays': value['missingDays'],
    };
}

